import type { CmmdMember, CmmdProject } from "@cmmd-forge/contracts";

type LeadAvatarProject = Pick<CmmdProject, "ownerAvatarUrl" | "ownerId" | "ownerName">;

/**
 * Project payloads often omit ownerAvatarUrl even when the lead is in /members
 * with a profile image. Resolve the photo from the project field first, then
 * members by owner id / exact display name.
 */
export function resolveProjectLeadAvatarUrl(
  project: LeadAvatarProject,
  members: readonly CmmdMember[],
): string | null {
  if (project.ownerAvatarUrl) return project.ownerAvatarUrl;
  const ownerId = project.ownerId != null ? String(project.ownerId) : null;
  if (ownerId) {
    const byId = members.find((member) => member.id === ownerId);
    if (byId?.avatarUrl) return byId.avatarUrl;
  }
  const ownerName = project.ownerName?.trim();
  if (ownerName) {
    const byName = members.find((member) => member.name.trim() === ownerName);
    if (byName?.avatarUrl) return byName.avatarUrl;
  }
  return null;
}

export function enrichProjectLeadAvatar(
  project: CmmdProject,
  members: readonly CmmdMember[],
): CmmdProject {
  const ownerAvatarUrl = resolveProjectLeadAvatarUrl(project, members);
  if (!ownerAvatarUrl || ownerAvatarUrl === project.ownerAvatarUrl) return project;
  return { ...project, ownerAvatarUrl };
}
